/** Moving to a new city through Talk: the work outlook, what to sort first, the guide's answers, mentors in the chat. */
export const moving = {
    "moving.suggest": "Moving to a new city?",
    "moving.no_figures": "{trade}: no usual pay figures for this city yet.",
    "moving.no_outlook": "I have no pay figures for that city yet.",
    "moving.listed.one": "On GigSync, {count} worker in {city} lists {trade}.",
    "moving.listed.other": "On GigSync, {count} workers in {city} list {trade}.",
    "moving.listed_many": "On GigSync, {count} or more workers in {city} list {trade}.",
    "moving.estimates": "These figures are estimates from public sources, not a promise of pay.",
    "moving.figures": "The figures",
    "moving.which_work": "Which work do you do? Then I can tell you the usual pay there.",
    "moving.first": "What to sort first in {city}:",
    "moving.no_guide": "I don't have a guide for that city yet. Only Bengaluru has one so far.",
    "moving.general": "What helps in any city:",
    "moving.lines": "Numbers that work anywhere in India:",
    "moving.line.emergency": "Emergency: police, fire, ambulance",
    "moving.line.women": "Women Helpline",
    "moving.line.eshram": "eShram helpdesk",
    "moving.line.cyber": "Cyber crime and online money fraud",
    "moving.line.legal": "Free legal aid (NALSA)",
    "moving.stay": "Where to stay",
    "moving.documents": "Documents",
    "moving.find": "Find someone who knows the city",
    "moving.checklist": "My moving checklist",
    "moving.places": "Places to stay listed in the guide ({count})",
    "moving.documents_lead": "What the guide says about documents. Tap one to read it.",
    "moving.no_answer": "The guide has nothing on that yet. Ask someone who knows the city, or call a helpline.",
    "moving.found": "People who know {city}, with their own count of work. Ask one, and they can say yes or no.",
    "moving.none": "No one who knows {city} matches yet.",
    "moving.more_ways": "More ways to find someone",
    "moving.ask": "Ask {name}",
    "moving.arrive": "When do you arrive in {city}?",
    "moving.arrive_0": "This week",
    "moving.arrive_1": "Next week",
    "moving.arrive_2": "In two weeks",
    "moving.sent": "Asked {name}. Their answer will show on Today.",
    "moving.not_eligible": "You can help newcomers after {min_months} months and {min_jobs} finished jobs on GigSync. Your phone counts {jobs} jobs over {months} months.",
    "moving.list_area": "Which area of {city} do you know best?",
    "moving.list_trades": "Which work can you tell newcomers about? Tap each one, then Done.",
    "moving.list_languages": "Which languages do you speak? Tap each one, then Done.",
    "moving.list_woman": "Are you a woman? It is used only so that women who ask for a woman can find you.",
    "moving.list_women_only": "Help women newcomers only?",
    "moving.list_slots": "How many newcomers at a time?",
    "moving.slots": "{n} at a time",
    "moving.done": "Done",
    "moving.list_confirm": "Newcomers will see: {name}, {area}, {trades}, speaks {langs}, {slots} at a time.",
    "moving.list_yes": "List me",
    "moving.list_no": "Not now",
    "moving.list_later": "All right. Say it again whenever you want to help.",
    "moving.unlisted": "You are off the list. Newcomers no longer see you.",
    "moving.not_listed": "You are not listed as someone who helps newcomers.",
};
//# sourceMappingURL=moving.js.map